import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'pipeTypeExcess'
})
export class PipeTypeExcess implements PipeTransform {
    transform(type) {
        if(type == '1'){
            return 'Un';
        }else{
            return 'Min';
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeTypeExcess.ts